import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { OverlayContentStyle } from '@website-builder/widgets/image/model/overlay-content-style';
import { OverlayButtonStyle } from '@website-builder/widgets/image/model/overlay-button-style';
import { OverlayTitleStyle } from '@website-builder/widgets/image/model/overlay-title-style';
import { ImageStyle } from '@website-builder/widgets/image/model/image-style';
import { ImageWrapperStyle } from '@website-builder/widgets/image/model/image-wrapper-style';
import { OverlayStyle } from '@website-builder/widgets/image/model/overlay-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class ImageWidget extends BaseWidget<ImageWrapperStyle> {
  readonly type = BuilderElementType.Image;
  src = 'assets/images/builder/placeholders/mountain.png';
  link = new TbLink();
  width: number;
  height: number;
  imageStyle: ImageStyle;
  style: ImageWrapperStyle;

  /* overlay */
  overlayStyle: OverlayStyle;
  fullCoverOverlay: boolean;
  overlayCoverStyle: string;
  overlayCoverTransition: string;
  overlayOnHover: boolean;
  overlayAnimateBackgroundOnly: boolean;
  linkType: string;

  /* title */
  title: string;
  titleStyle: OverlayTitleStyle;

  /* subtitle */
  subtitle: string;
  subtitleStyle: OverlayTitleStyle;

  content = '';
  contentStyle: OverlayContentStyle;

  /* button */
  buttonText: string;
  buttonStyle: OverlayButtonStyle;

  constructor() {
    super();
    this.overlayCoverStyle = this.overlayCoverTransition = '';
    this.imageStyle = new ImageStyle();
    this.overlayStyle = new OverlayStyle();
    this.titleStyle = new OverlayTitleStyle();
    this.subtitleStyle = new OverlayTitleStyle();
    this.contentStyle = new OverlayContentStyle();
    this.buttonStyle = new OverlayButtonStyle();
    this.style = new ImageWrapperStyle();
    this.linkType = 'image';
  }

  static normalizeInPlace(widget: ImageWidget): ImageWidget {
    const pureWidget = new ImageWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.src = widget.src ?? pureWidget.src;
    widget.link = TbLink.normalizeInPlace(widget.link ?? pureWidget.link);
    widget.width = widget.width ?? pureWidget.width;
    widget.height = widget.height ?? pureWidget.height;
    widget.fullCoverOverlay = widget.fullCoverOverlay ?? pureWidget.fullCoverOverlay;
    widget.overlayCoverTransition = widget.overlayCoverTransition ?? pureWidget.overlayCoverTransition;
    widget.overlayOnHover = widget.overlayOnHover ?? pureWidget.overlayOnHover;
    widget.overlayAnimateBackgroundOnly =
      widget.overlayAnimateBackgroundOnly ?? pureWidget.overlayAnimateBackgroundOnly;
    widget.linkType = widget.linkType ?? pureWidget.linkType;
    widget.title = widget.title ?? pureWidget.title;
    widget.subtitle = widget.subtitle ?? pureWidget.subtitle;
    widget.buttonText = widget.buttonText ?? pureWidget.buttonText;

    widget.imageStyle = ImageStyle.normalize(widget.imageStyle);
    widget.overlayStyle = OverlayStyle.normalize(widget.overlayStyle);
    widget.titleStyle = OverlayTitleStyle.normalize(widget.titleStyle);
    widget.subtitleStyle = OverlayTitleStyle.normalize(widget.subtitleStyle);
    widget.contentStyle = OverlayContentStyle.normalize(widget.contentStyle);
    widget.buttonStyle = OverlayButtonStyle.normalize(widget.buttonStyle);
    widget.style = ImageWrapperStyle.normalize(widget.style);

    return widget;
  }
}
